import { EhrData } from 'chaika-frontend-types/frontend-cms';

import { PatientStoreModel } from '@store/models/Patient/PatientStoreModel';

import { PatientList } from './PatientList';
import { SearchPatientList } from './SearchPatientList';

export class PatientStore extends PatientStoreModel<EhrData> {
    public static Name = 'patientStore' as const;

    public lastViewPatientList = new PatientList();
    public patientList = new PatientList();
    public searchList = new SearchPatientList();
}

export const patientStore = new PatientStore();
